module.exports = "https://extension.videomatik.com.br/files/textLeadingAuto.png";